export default "__VITE_ASSET__ada8da03__"